{
    "header": {},
    "footer": {},
    "page": {
        "select-device": {
            "fluidnc": "Usa questa opzione se vuoi installare, aggiornare o configurare il tuo dispositivo Arabesque.",
            "continue": "Continua"
        },
        "connection": {
            "title": "Arabesque Web Installer",
            "description": "Questo strumento renderà facile installazione o aggiornamento Arabesque sul tuo dispositivo. Collega il controller e premi Connetti per continuare.",
            "connect": "Connetti",
            "connecting": "Connessione in corso",
            "establishing-connection": "Stabilire la connessione al controller"
        },
        "home": {
            "description": "Sei ora connesso a un dispositivo, scegli un'azione qui sotto",
            "error-while-booting": "Si è verificato un errore durante l'avvio, probabilmente dovuto a una configurazione non valida.",
            "show-details": "Clicca qui per vedere i dettagli"
        },
        "file-browser": {
            "title": "Browser dei file",
            "loading": "Caricamento in corso...",
            "downloading": "Download in corso...",
            "uploading": "Caricamento",
            "config-missing": "Il file di configurazione \"{{configFilename}}\" è mancante, vuoi crearlo?",
            "create-config": "Crea Configurazione",
            "create-new-config": "Crea una nuova configurazione",
            "upload": "Upload",
            "active-config": "Configurazione attiva",
            "select-config": "Seleziona configurazione",
            "select-as-config": "Seleziona come configurazione",
            "edit": "Modifica",
            "delete": "Elimina",
            "download": "Scarica"
        },
        "terminal": {
            "title": "Terminale",
            "restarting": "Riavvio del controller...",
            "restart": "Riavvia",
            "restart-description": "Esegue un azzeramento hardware del controller impostando DTR/RTS",
            "reset": "Ripristina",
            "reset-description": "Resetta il controller con un comando 0x18",
            "unlock": "Sblocca",
            "unlock-description": "Sblocca il controller con $X",
            "status": "Stato",
            "status-description": "Ottieni lo stato del controller",
            "startup": "Messaggi di avvio",
            "startup-description": "Ottieni i messaggi del registro di avvio",
            "version": "Versione",
            "version-description": "Ottieni la versione del firmware"
        },
        "not-found": {
            "title": "Pagina non trovata.",
            "go-back-home": "Torna alla home"
        }
    },
    "panel": {
        "navigation": {
            "home": "Home",
            "install": "Installa",
            "terminal": "Terminale",
            "file-browser": "Sfoglia File",
            "wifi": "WiFi",
            "calibrate": "Calibra",
            "stacktrace-decoder": "Decodifica Stack Trace",
            "restart": "Riavvia",
            "disconnect": "Disconnetti"
        },
        "firmware": {
            "install": "Installa",
            "install-description": "Seleziona quale firmware vuoi installare sul tuo controller.",
            "loading": "Caricamento...",
            "install-custom-image": "Installa un'immagine personalizzata...",
            "show-prereleases": "Mostra pre-release",
            "fetching": "Recupero in corso..."
        },
        "progress": {
            "title": "Installazione in corso",
            "downloading": "Download del pacchetto...",
            "validating": "Convalida immagini...",
            "flashing": "Installazione del pacchetto sul dispositivo..."
        },
        "bootloader": {
            "waiting": "In attesa che il controller entri in modalità bootloader...",
            "not-active": "Bootloader non attivo - Prova a tenere premuto l'interruttore BOOT"
        },
        "unsupported": {
            "title": "Browser non supportato",
            "description": "Il tuo browser attuale non è supportato, usa Chrome, Edge o Opera."
        }
    },
    "component": {
        "log": {
            "show-details": "Mostra dettagli",
            "hide-details": "Nascondi dettagli"
        }
    },
    "modal": {
        "installer": {
            "error-reconnecting": "Si è verificato un errore durante la riconnessione, riavvia il controller",
            "uploading": "Caricamento",
            "downloading": "Download in corso",
            "downloading-description": "Download del pacchetto...",
            "restarting": "Riavvio in corso",
            "restarting-description": "In attesa del riavvio del controller...",
            "uploading-files": "Caricamento file",
            "uploading-files-description": "Caricamento file...",
            "done": "Completato",
            "done-description": "Il controller è stato installato con successo ed è pronto all' uso.",
            "continue": "Continua",
            "error": "Errore!",
            "close": "Chiudi",
            "confirm-installation": "Conferma installazione",
            "confirm-installation-description": "Questo installerà il firmware \"{{release}}\" nel controller. {{not}} cancellerà il contenuto del controller",
            "not": "Non",
            "installation-speed": "Velocità di installazione",
            "installation-speed-help": "Alcuni controller devono essere installati a una velocità inferiore. Se si verificano problemi si può provare a diminuire la velocità.",
            "install": "Installa",
            "cancel": "Cancella",
            "select-image": "Seleziona l'immagine",
            "select-image-description1": "Se hai scaricato manualmente un pacchetto puoi flashare l'immagine da qui.",
            "select-image-description2": "Selezionare il file firmware.bin con cui flashare il controller.",
            "select-image-button": "Seleziona immagine firmware"
        },
        "lost-connection": {
            "description": "Connessione al controller interrotta",
            "close": "Chiudi"
        }
    },
    "card": {
        "install": {
            "upgrade-description": "Aggiorna Arabesque da",
            "install-description": "Il controller non sembra avere Arabesque installato, vuoi installarlo?",
            "upgrade-button": "Aggiorna Arabesque",
            "install-button": "Installa Arabesque"
        },
        "terminal": {
            "open-terminal": "Apri terminale",
            "open-terminal-description": "Apri un terminale seriale verso il tuo controller"
        },
        "file-browser": {
            "open-browser": "Browser dei file",
            "open-browser-description": "Gestisci i file sul controller"
        },
        "calibrate": {
            "calibrate": "Calibra",
            "calibrate-description": "Calibra le impostazioni sul tuo controller"
        },
        "wifi": {
            "configure": "Configura WiFi",
            "configure-description": "Gestisci le impostazioni WiFi del controller",
            "connected-to": "Connesso a",
            "access-point": "Access Point"
        },
        "stacktrace": {
            "open": "Decodifica Stack Trace",
            "description": "Decodifica gli stack trace di ESP32 usando i file .addrinfo"
        }
    }
}
